import { type Attrs, type DOMOutputSpec, type Node, type NodeSpec } from "prosemirror-model";

export const inline_image: NodeSpec = {
	attrs: {
		src: { default: "" },
		alt: { default: "" },
		title: { default: null },
	},
	inline: true,
	group: "inline",
	atom: true,
	parseDOM: [
		{
			tag: "img[data-inline-image]",
			getAttrs(node: string | HTMLElement) {
				if (!(node instanceof HTMLImageElement)) {
					return false;
				}

				const attrs: Attrs = {
					src: node.getAttribute("src") ?? "",
					alt: node.getAttribute("alt") ?? "",
					title: node.getAttribute("title"),
				};

				return attrs;
			},
		},
	],
	toDOM(node: Node): DOMOutputSpec {
		return [
			"img",
			{
				"src": node.attrs["src"],
				"alt": node.attrs["alt"],
				"title": node.attrs["title"],
				"data-inline-image": "true",
			},
		];
	},
};
